<script>
export default {
  props: {
    color: {
      type: String,
      default: 'primary'
    }
  }
}
</script>
<template>
  <v-icon
    class="close-icon pt-2 pr-2"
    :color="color"
    medium
    @click="$emit('click')"
  >mdi-close</v-icon
  >
</template>
<style lang="scss" scoped>
.close-icon {
  position: absolute;
  top: 5px;
  right: 5px;
}
</style>
